import React, { useEffect, useState, version } from "react";
import Widgets from "../../../widgets";
import strings from "../../../utils/strings";
import { useTranslation } from "react-i18next";
import Icons from "../../../Assets/Icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetGetVersionList } from "../../../modules/TNC/tncSlice";
import { getVersionList } from "../../../modules/TNC/tncThunk";
import ToastPopup from "../../../widgets/Toast/toastPopup";
import moment from "moment";

const ListTermsCondition = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const breadcrumbs = ["tncPP"];
  const paths = [strings.navigation.termsCondition];
  const { t } = useTranslation();
  const { versionListSuccess, versionListErr } = useSelector((state) => state.tnc);
  const [versionList, setVersionList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchVersions();
  }, []);

  const fetchVersions = (pageNumber = currentPage, limit = itemsPerPage) => {
    const page = pageNumber ?? currentPage ?? 1;
    dispatch(getVersionList({ page, limit }));
  };

  useEffect(() => {
    if (versionListErr) {
      // ToastPopup.error(versionListErr);
    }
    if (versionListSuccess && versionListSuccess.status === "success") {
      setVersionList(versionListSuccess.data);
      setCurrentPage(versionListSuccess.data.currentPage);
      setTotalPages(versionListSuccess.data.totalPages);
    }
    dispatch(resetGetVersionList());
  }, [versionListSuccess, versionListErr]);

  const handleVerifyClick = (item, status) => {
    if (status === "SAVED") {
      nav(strings.navigation.updateTermsCondition);
    } else {
      nav(`${strings.navigation.viewTermsCondition}?id=${item}`);
    }
  };

  const handleUpdateNav = () => {
    nav(strings.navigation.updateTermsCondition);
  };

  const handlePrevNext = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      fetchVersions(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchVersions(currentPage + 1);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };
  const handleClick = (pageNumber) => {
    fetchVersions(pageNumber);
  };

  return (
    <div className="department-box article-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">{t("tncVersionList")}</div>
      </div>
      <div className="department-search-line">
        <div></div>
        <Widgets.IconButton iconSrc={Icons.edit} buttonText={versionList?.versions?.length === 0 ? "createDoc" : "update"} onClick={handleUpdateNav} />
      </div>
      <div className="ppl-list-container">
        <div className="ppl-table-body">
          <table className="ppl-table">
            <thead className="ppl-thead tnc-body">
              <tr>
                <th>{t("version")}</th>
                <th>{t("date")}</th>
                <th>{t("editedBy")}</th>
                <th>{t("status")}</th>
              </tr>
            </thead>
            <tbody className="ppl-tbody dp-tbody tnc-body">
              {versionList?.versions?.length > 0 &&
                versionList?.versions?.map((item) => {
                  return (
                    <tr key={item._id} className="ppl-table-row " onClick={() => handleVerifyClick(item._id, item.status)}>
                      <td>{item.version}</td>
                      <td>{moment(item.updatedAt).format("MMMM Do YYYY, h:mm:ss A")}</td>
                      <td>{item.editedBy.name}</td>
                      <td className={"status-head"}>
                        {item.status === "OUTDATED" || !item.status ? null : (
                          <div className={item.status === "PUBLISHED" ? "publish-status status-icon" : "draft-status status-icon"}>
                            <img src={item.status === "PUBLISHED" ? Icons.publish : item.status === "SAVED" ? Icons.draft : null} alt="status" />
                            {item.status === "OUTDATED" ? null : item.status === "SAVED" ? "Draft" : item.status}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {versionList?.versions?.length === 0 && (
            <div className="no-record-container">
              <div className="no-record-icon">
                <img src={Icons.NoData} alt="No Data Found" />
              </div>
              <div className="no-record-text">{t("noRecordFound")}</div>
            </div>
          )}
        </div>
        <div className="department-pagination-list">
          {totalPages > 0 && (
            <>
              <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
                <img src={Icons.leftArrow} alt="<" />
              </button>
              {renderPagination().map((page, index) => (
                <button
                  key={index}
                  onClick={() => typeof page === "number" && handleClick(page)}
                  disabled={page === currentPage || page.type === "ellipsis"}
                  className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
                >
                  {typeof page === "number" ? page : <img src={Icons.extraIcon} alt="..." className="department-extra-icon" />}
                </button>
              ))}
              <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
                <img src={Icons.rightArrow} alt=">" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListTermsCondition;
